import { render } from "./admissionProcedureList.vue?vue&type=template&id=7bc1cc36&ts=true"
import script from "./admissionProcedureList.vue?vue&type=script&lang=ts"
export * from "./admissionProcedureList.vue?vue&type=script&lang=ts"

import "./admissionProcedureList.vue?vue&type=style&index=0&id=7bc1cc36&lang=css"

import exportComponent from "/home/devadm/tuyensinh-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__